import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonList, Overlay, StatusBar } from "../../Components";
import { GlobalMenu, SystemMenu } from "../";
import { colors, fonts, frames, glyphs, icons, useMediaQuery } from "../../Styles";
import { Outlet, useLocation } from "react-router-dom";
import LogoDisplay from "../../Components/logoDisplay";
import { ButtonTypes, Clock, ListStyle_Types } from '../../Definitions';
import StatusList from '../../Components/statusList';
import { Pages } from '../Routers/root';
import { createPortal } from 'react-dom';
import MenuButton from '../../Components/menuButton';
import LanguageSelector from '../../Components/languageSelector';
import { useUser } from '../../Services';

// #region | CloudpanelLayoutDesktop
const CloudpanelLayoutDesktop = () => {
  const {serverIp, getServerIp} = useUser()
  useEffect(() => {
    getServerIp()
  },[])

  return (
    <frames.CloudPanel>
      <LogoDisplay overrides={{ gridArea: "logoDisplay" }} ChooseSite selectedPage={Pages.kpi}/>
      <GlobalMenu overrides={{ gridArea: "globalMenu" }}/>
      <SystemMenu overrides={{ gridArea: "systemMenu" }} />
      <StatusBar overrides={{ gridArea: "statusBar" }} />
      <frames.LanguageSelector>
        <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary }}>{serverIp}</p>
        <div style={{width: "2px", height: "50%", backgroundColor: colors.greyDarkSecondary}}/>
        <Clock />
        <div style={{width: "2px", height: "50%", backgroundColor: colors.greyDarkSecondary}}/>
        <LanguageSelector isPrimary/>
      </frames.LanguageSelector> 
      <div style={{ gridArea: "page_outer", overflow: "hidden"}}>
        <Outlet /> 
      </div>
    </frames.CloudPanel>
  );
};
// #endregion
// ---------------------------------

// #region | CloudpanelLayoutMobile
const CloudpanelLayoutMobile = () => {
  const {t} = useTranslation()
  const location = useLocation();

  const groupMenu2columns = useMediaQuery(`(max-width: 454px)`)
  const groupMenu3columns = useMediaQuery(`(min-width: 455px) and (max-width: 590px)`)

  const [menuOpen, setMenuOpen] = useState(false);

  const [showGlobalMenu, setShowGlobalMenu] = useState(true);
  const [showSystemMenu, setShowSystemMenu] = useState(false);
  const [showStatusBar, setShowStatusBar] = useState(false);

  const BtnFunc_Router = (btn_index: number) => {
    switch (btn_index) {
      case 0:
        setShowGlobalMenu(true);
        setShowSystemMenu(false);
        setShowStatusBar(false);
        break;
      case 1:
        setShowSystemMenu(true);
        setShowGlobalMenu(false);
        setShowStatusBar(false);
        break;
      case 2:
        setShowStatusBar(true);
        setShowGlobalMenu(false);
        setShowSystemMenu(false);
        break;
      default:
        break;
    }
  };

  const _style: React.CSSProperties = {
    gridArea: "2/1/3/2",
    display: "flex",
    alignItems: "end",
    overflow: "hidden",
    maxHeight: "100%"
  };

  // To show or not to show mobile menu
  const toggleComponents = () => {
    setMenuOpen(!menuOpen);
  };

  // Reset showComponents to false when the location changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return ( <>
    <MenuButton menuState={menuOpen} onClick={toggleComponents}/>

    <frames.CloudPanel>
      {menuOpen && createPortal ( <>
        <Overlay 
          // onClick={toggleComponents}
          overrides={{
            zIndex: menuOpen ? 99999 : 0,
            blur: true
          }}
          content={
            <div style={{boxSizing: "border-box", display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "150px 1fr auto", rowGap: "10px", position: "relative", zIndex: "999999", padding: "10px", height: "100%", width: "100%"}}>
              <div style={{gridArea: "1/1/2/2"}}><LogoDisplay ChooseSite selectedPage={Pages.kpi}/></div>
              <div style={{gridArea: "2/1/3/2", display: "flex", alignItems: "end"}}>{showGlobalMenu && <GlobalMenu/>}</div>
              <div style={_style}>{showSystemMenu && <SystemMenu/>}</div>
              <div style={_style}>{showStatusBar && <StatusList/>}</div>
              <div style={{gridArea: "3/1/4/2"}}>
                <div style={{width: "100%", height: "fit-content", maxWidth: "555px", padding: "7.5px", boxSizing: "border-box", backgroundColor: colors.greyDarkPrimary, borderRadius: (showGlobalMenu||showSystemMenu||showStatusBar) ? "0px 0px 10px 10px" : "10px", margin: "0px auto", display: "flex", justifyContent: "center"}}>
                <div style={{width: groupMenu2columns ? "265px" : groupMenu3columns ? "400px" : "535px"}}>
                  <ButtonList contents={[t("menuHeaders.globalMenu", {defaultValue: "global menu"}), t("menuHeaders.systemMenu", {defaultValue: "system menu"}), t("menuHeaders.attentions", {defaultValue: "attentions"}), t("menuHeaders.language", {defaultValue: "language"})]}
                    onClick={(e) => BtnFunc_Router(e)}
                    buttonType={ButtonTypes.globalMenuButton}
                    overrides={{
                      startEnhancerStyles: {width: "25px", height: "25px"},
                      hoverStyles: {backgroundColor: colors.greyDarkSecondary}
                    }}
                    hasActiveLoad
                    listOverrides={{
                      listStyle: ListStyle_Types.group
                    }}
                    startEnhancers={[
                      icons.globalSettings, icons.globalSettings, icons.globalSettings, icons.globalSettings
                    ]}/>
                  </div>
                </div>
              </div>
            </div>
          }
        /> 
      </>, document.body )}
      <div style={{ gridArea: "page_outer", overflow: "hidden"}}>
        <Outlet /> 
      </div>
    </frames.CloudPanel>
  </> );
};
// #endregion
// ---------------------------------

const CloudpanelLayout = () => {
  const mobile = useMediaQuery(`(max-width: 1000px)`);
  return ( <>
    {mobile ? <CloudpanelLayoutMobile/> : <CloudpanelLayoutDesktop/>}
  </> )
}

export default CloudpanelLayout